<template>
  <div class="fclca-form">
    <div class="fclca-tips">
      <h5>
        Please send your prescription pictures to us, we need clear information
        about your name, power/sphere of both eyes, issued date, and expire date
        of the prescription.
      </h5>
    </div>
    <div class="fclca-form-content">
      <div class="fclca-form-upload">
        <el-upload
          ref="upload"
          drag
          :action="API.prescriptions_attachments"
          multiple
          :limit="5"
          :on-exceed="exceed"
          :on-success="upload_success"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          name="files[]"
          accept=".png,.jpg,.jpeg,.gif"
          :disabled="!!(gallery.length&&gallery.length==5)"
        >
          <div v-for="(item, index) in gallery" :key="item.ID" @click.stop>
            <div class="fclca-img-thumbnail">
              <span
                class="fclca-img-del"
                @click="delete_img(index, item)"
              ></span>
              <img :src="item.thumbnail" alt="" />
            </div>
          </div>
          <div class="el-upload-tips">
            <div v-if="gallery.length&&gallery.length==5">
              <p class="position-center">
                A maximum of 5 images Delete to add new
              </p>
            </div>
            <div v-else>
              <div class="el-upload_position-center">
                <i class="el-icon-upload"></i>
                <div class="upload-add-btn">
                  <span>Add file</span>
                </div>
                <div class="el-upload__text">or drop file to upload</div>
              </div>
            </div>
          </div>
        </el-upload>
      </div>
      <form @submit.prevent="submit">
        <v-fclcaConfirm
          ref="certify"
          id="fieldCertify2"
          v-model="certify"
          :value="certify"
          :error="certify_error"
          content="I certify that the prescription attached is true,accurate and obtained from certifiled Doctor and Optometrist. I have sufficient knowledge to handle plano lenses."
        ></v-fclcaConfirm>
        <button type="submit" ref="submit" class="d-none"></button>
      </form>
    </div>
  </div>
</template>
<script>
import vFclcaInput from "./fclcaInput.vue";
// import API from "../../../API";
import vFclcaConfirm from "./fclcaConfirm.vue";
export default {
  props: ["certify", "fclca_gallery"],
  data() {
    return {
      gallery: [],
      API,
      certify_error: false,
    };
  },
  methods: {
    beforeAvatarUpload(file) {
      if (this.gallery && this.gallery.length > 4) {
        this.exceed();
        return false;
      }
      console.log(file.type);
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif" ||
        file.type === "image/jpg";
      const isLt5M = file.size / 1024 / 1024 <= 5;
      if (!isLt5M) {
        this.$message.error(this.$t("comment.5MB"));
      }
      if (!isJPG) {
        this.$message.error(this.$t("comment.upload_images"));
      }
      return isJPG && isLt5M;
    },
    delete_img(index, item) {
      this.$refs.upload.handleRemove(item);
      this.gallery.splice(index, 1);
    },
    upload_success(response) {
      this.gallery.push(response[0]);
    },
    //超出最大数量
    exceed() {
      this.$message.error(this.$t("comment.maximum5"));
    },
    gether() {
      setTimeout(() => {
        if (!this.certify) {
          let el = this.$("#fieldCertify2");
          let top = el.offset().top;
          this.$("html,body").animate({ scrollTop: top - 50 }, 200);
        }
      }, 0);
      this.$refs.submit.click();
    },
    submit() {
      if (this.gallery && this.gallery.length) {
        this.bus.$emit("fclca-form-sent", this.gallery);
      } else {
        this.$message.error("Please upload prescription");
      }
    },
  },
  components: {
    vFclcaInput,
    vFclcaConfirm,
  },
  watch: {
    gallery(newV) {
      if (newV && newV.length > 5) {
        this.gallery.splice(5);
      }
    },
    fclca_gallery(newV) {
      this.gallery = newV;
    },
  },
};
</script>
<style scoped lang='scss'>
.fclca-form {
  label {
    margin: 0;
  }
  .fclca-tips {
    h5 {
      font-size: 16px;
      font-family: Roboto;
      font-weight: 400;
      color: #3a3a3a;
      line-height: 24px;
      margin: 0;
    }
  }
  .fclca-form-content {
    .fclca-form-upload {
      margin: 35px 0 20px;
      padding: 15px 30px 15px;
      @media screen and(max-width:768px) {
        padding: 7.5px 15px;
      }
      border: 1px solid #cccccc;
      &::v-deep {
        & > div {
          display: flex;
          .el-upload {
            border: none;
            width: 100%;
            .el-upload-dragger {
              border-radius: 0;
              width: auto;
              height: auto;
              border: none;
              display: flex;
              line-height: 1;
              flex-wrap: wrap;
              margin: 0 -15px;
              background-color: transparent;
              @media screen and(max-width:768px) {
                margin: 0 -7.5px 0;
              }
              & > div {
                width: 33.33%;
                max-width: 33.33%;
                min-width: 33.33%;
                padding: 15px;
                @media screen and(max-width:768px) {
                  padding: 7.5px;
                }
              }

              .fclca-img-thumbnail {
                background-color: #f2f2f3;
                width: 100%;
                padding-top: 100%;
                position: relative;
                .fclca-img-del {
                  position: absolute;
                  top: -12px;
                  right: -12px;
                  width: 24px;
                  height: 24px;
                  background: #ef2b39;
                  border-radius: 50%;
                  z-index: 1;
                  &::after {
                    position: absolute;
                    display: block;
                    left: 5px;
                    top: 11px;
                    width: 14px;
                    height: 2px;
                    content: "";
                    background: #ffffff;
                    border-radius: 1px;
                  }
                  @media screen and(max-width: 768px) {
                    width: 12px;
                    height: 12px;
                    top: -6px;
                    right: -6px;
                    &::after {
                      left: 2.5px;
                      top: 5.5px;
                      width: 7px;
                      height: 1px;
                    }
                  }
                }
                img {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .el-upload-tips {
                border-radius: 0px;
                & > div {
                  width: 100%;
                  padding-top: 100%;
                  position: relative;
                  border: 2px dashed #8c9196;
                  p {
                    width: 100%;
                    color: #8c9196;
                    font-size: 14px;
                    line-height: 15px;
                    padding: 0 10px;
                    margin-bottom: 0;
                    @media screen and(max-width: 768px) {
                      font-size: 12px;
                    }
                  }
                }
              }
              .el-upload-tips:first-child:nth-child(1) {
                width: 100%;
                max-width: 100%;
                min-width: 100%;
                & > div {
                  padding-top: unset;
                  position: unset;
                  padding-bottom: 42px;
                  .upload-add-btn {
                    margin-bottom: 14px;
                    span {
                      display: inline-block;
                      padding: 11px 25px;
                      border: 1px solid #a5abb0;
                      color: #222222 !important;
                    }
                  }
                }
                @media screen and(max-width:768px) {
                  & > div {
                    padding-top: unset;
                    position: unset;
                    padding-bottom: 20px;
                    .el-icon-upload {
                      margin: 8px 0 0;
                      font-size: 40px;
                    }
                    .upload-add-btn {
                      margin-bottom: 0;
                      span {
                        font-size: 12px;
                        display: inline-block;
                        padding: 8px 18px;
                        border: 1px solid black;
                      }
                    }
                    .el-upload__text {
                      display: none;
                    }
                  }
                }
              }
            }
            .el-upload-dragger>div:not(:first-child){
              .el-upload_position-center{
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
               
                .el-icon-upload {
                   display: none;
                }
                .upload-add-btn {
                  margin-bottom: 16px;
                  span {
                    font-size: 12px;
                    display: inline-block;
                    padding: 8px 18px;
                    border: 1px solid black;
                  }
                }
                .el-upload__text {
                     padding: 0 12px;
                }
                @media screen and(max-width:768px) {
                 
                    .el-icon-upload {
                      display:unset;
                      margin: 8px 0 0;
                      font-size: 36px;
                    }
                    .upload-add-btn {
                      margin-bottom: 0;
                      span {
                        font-size: 12px;
                        display: inline-block;
                        padding: 8px 18px;
                        border: unset;
                      }
                    }
                    .el-upload__text {
                      display: none;
                    }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>